var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityGameJamsFocused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab03_filled 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.46 47.0951L17.1864 43.7099C16.2812 42.7799 15.9588 41.4407 16.368 40.1883C16.678 39.2211 17.112 37.9439 17.6204 36.4931H6.39837C5.48077 36.4931 4.63757 35.9847 4.17877 35.1663C3.71997 34.3479 3.73237 33.3435 4.20357 32.5251L9.77117 22.8407C11.1476 20.4475 13.64 18.9843 16.3308 18.9843H25.0604C25.3208 18.5503 25.5688 18.1411 25.8292 17.7443C34.5216 4.5259 47.4548 4.0919 55.18 5.5551C56.42 5.7907 57.3748 6.7827 57.598 8.0475C59.024 16.0331 58.59 29.3631 45.7808 38.3283C45.4088 38.5887 45.012 38.8491 44.5904 39.1219V48.1243C44.5904 50.9019 43.1644 53.4811 40.8456 54.8947L31.4464 60.6359C30.6652 61.1195 29.6856 61.1319 28.892 60.6607C28.0984 60.1895 27.6148 59.3215 27.6148 58.3791V46.6487C26.1144 47.1819 24.8124 47.6159 23.8204 47.9507C22.63 48.3351 21.3404 48.0003 20.46 47.0951ZM44.5904 23.3615C45.7064 23.3615 46.7852 22.9027 47.5912 22.0843C48.3848 21.2535 48.8312 20.1499 48.8312 18.9843C48.8312 17.8187 48.3848 16.7151 47.5912 15.8843C46.7852 15.0659 45.7064 14.6071 44.5904 14.6071C43.462 14.6071 42.3832 15.0659 41.5896 15.8843C40.7836 16.7151 40.3372 17.8187 40.3372 18.9843C40.3372 20.1499 40.7836 21.2535 41.5896 22.0843C42.3832 22.9027 43.462 23.3615 44.5904 23.3615Z",
    fill: "#9FD1FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityGameJamsFocused);
export default __webpack_public_path__ + "static/media/activity-game-jams-focused.72c7bb3d1d657d91bb447f9ab29a9681.svg";
export { ForwardRef as ReactComponent };